/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PatientRootAliases {
  APPLICATION_BAR = 'application-bar',
  APPOINTMENT_DETAIL_FRAGMENT = 'appointment-detail-fragment',
  APPOINTMENT_DETAIL_ROUTE = 'appointment-detail-route',
  APPOINTS_LIST_FRAGMENT = 'appoints-list-fragment',
  APPOINTS_LIST_ROUTE = 'appoints-list-route',
  AUTOLOGOUT_FRAGMENT = 'autologout-fragment',
  AUTOLOGOUT_ROUTE = 'autologout-route',
  AVATAR_0 = 'avatar-0',
  AVATAR_HOLDER = 'avatar-holder',
  AVATAR_PROFILE_DROPDOWN = 'avatar-profile-dropdown',
  CARD_CONTAINER_DEPENDENTS = 'card-container-dependents',
  CARD_CONTAINER_HOLDER = 'card-container-holder',
  CARD_CONTAINER_SEPARATOR_0 = 'card-container-separator-0',
  CARD_CONTAINER_SEPARATOR_1 = 'card-container-separator-1',
  CHEMOTHERAPY_APPOINTMENT_DETAILS_FRAGMENT = 'chemotherapy-appointment-details-fragment',
  CHEMOTHERAPY_APPOINTMENT_DETAILS_ROUTE = 'chemotherapy-appointment-details-route',
  CONFIGURATION_FRAGMENT = 'configuration-fragment',
  CONFIGURATION_ROUTE = 'configuration-route',
  CONSULTATION_DETAILS_FRAGMENT = 'consultation-details-fragment',
  CONSULTATION_DETAILS_ROUTE = 'consultation-details-route',
  CONTENT_PANEL = 'content-panel',
  DASHBOARD_FRAGMENT = 'dashboard-fragment',
  DASHBOARD_ROUTE = 'dashboard-route',
  DECK_DEPENDENTS = 'deck-dependents',
  DROP_DOWN_MENU_USER_PROFILE = 'drop-down-menu-user-profile',
  EXAM_DETAILS_FRAGMENT = 'exam-details-fragment',
  EXAM_DETAILS_LAB_FRAGMENT = 'exam-details-lab-fragment',
  EXAM_DETAILS_ROUTE = 'exam-details-route',
  EXAM_LAB_DETAILS_ROUTE = 'exam-lab-details-route',
  EXAM_RESULTS_FRAGMENT = 'exam-results-fragment',
  EXAM_RESULTS_ROUTE = 'exam-results-route',
  FETCH_NOTIFICATION = 'fetch-notification',
  FETCH_USER_PROFILE = 'fetch-user-profile',
  FETCH_USER_PROFILE_HOLDER = 'fetch-user-profile-holder',
  FRAGMENT_CHANGE_PASSWORD = 'fragment-change-password',
  FRAGMENT_NEW_APPOINTMENT = 'fragment-new-appointment',
  FRAGMENT_PROFILE_PRIVACY = 'fragment-profile-privacy',
  LAYOUT_DEPENDENTS = 'layout-dependents',
  LAYOUT_DEPENDENTS_LIST = 'layout-dependents-list',
  LAYOUT_PATIENT_HOLDER = 'layout-patient-holder',
  MAPPER_DEPENDENTS = 'mapper-dependents',
  MAPPER_USER_PROFILE = 'mapper-user-profile',
  MAPPER_USER_PROFILE_HOLDER = 'mapper-user-profile-holder',
  MATERIAL_EDUCATIONAL = 'material-educational',
  MATERIAL_EDUCATIONAL_DETAIL_FRAGMENT = 'material-educational-detail-fragment',
  MATERIAL_EDUCATIONAL_DETAIL_ROUTE = 'material-educational-detail-route',
  MATERIAL_EDUCATIONAL_ROUTE = 'material-educational-route',
  MY_CHART_FRAGMENT = 'my-chart-fragment',
  MY_CHART_ROUTE = 'my-chart-route',
  NEW_APPOINTMENT_FRAGMENT = 'new-appointment-fragment',
  NEW_APPOINTMENT_ROUTE = 'new-appointment-route',
  NOTIFICATION_CENTER = 'notification-center',
  OPTION_LOGOUT = 'option-logout',
  OPTION_PROFILE = 'option-profile',
  PANEL_APPLICATION_BAR = 'panel-application-bar',
  PANEL_DEPENDENTS = 'panel-dependents',
  PANEL_DROPDOWN = 'panel-dropdown',
  PANEL_DROPDOWN_PROFILE_HEADER = 'panel-dropdown-profile-header',
  PANEL_NOTIFICATION = 'panel-notification',
  PANEL_TELECONSULTATION = 'panel-teleconsultation',
  PROFILE_FRAGMENT = 'profile-fragment',
  PROFILE_GUIDANCE_AND_REGUALTORY_MODAL = 'profile-guidance-and-regualtory-modal',
  PROFILE_GUIDANCE_AND_REGULATORY_ROUTE = 'profile-guidance-and-regulatory-route',
  PROFILE_ROUTE = 'profile-route',
  PSEUDONYM_APPOINTMENT_CHECKUP_RESCHEDULE = 'pseudonym-appointment-checkup-reschedule',
  PSEUDONYM_APPOINTMENT_CHECKUP_RESCHEDULE_FRAGMENT = 'pseudonym-appointment-checkup-reschedule-fragment',
  PSEUDONYM_APPOINTMENT_DETAIL_FRAGMENT = 'pseudonym-appointment-detail-fragment',
  PSEUDONYM_APPOINTMENT_DETAIL_ROUTE = 'pseudonym-appointment-detail-route',
  PSEUDONYM_APPOINTMENT_FORM_FRAGMENT = 'pseudonym-appointment-form-fragment',
  PSEUDONYM_APPOINTMENT_FORM_ROUTE = 'pseudonym-appointment-form-route',
  PSEUDONYM_APPOINTMENT_FRAGMENT = 'pseudonym-appointment-fragment',
  PSEUDONYM_APPOINTMENT_ROUTE = 'pseudonym-appointment-route',
  REQUEST_APPOINTMENT_DETAILS_FRAGMENT = 'request-appointment-details-fragment',
  REQUEST_APPOINTMENT_DETAILS_ROUTE = 'request-appointment-details-route',
  RESCHEDULE_APPOINTMENT_FRAGMENT = 'reschedule-appointment-fragment',
  RESCHEDULE_APPOINTMENT_ROUTE = 'reschedule-appointment-route',
  ROOT_FOOTER = 'root-footer',
  ROOT_LAYOUT = 'root-layout',
  ROUTE_CHANGE_PASSWORD = 'route-change-password',
  ROUTE_NEW_APPOINTMENT = 'route-new-appointment',
  ROUTE_PROFILE_PRIVACY = 'route-profile-privacy',
  SERVICE_DETAILS_FRAGMENT = 'service-details-fragment',
  SERVICE_DETAILS_ROUTE = 'service-details-route',
  SURGERY_APPOINTMENT_DETAILS_FRAGMENT = 'surgery-appointment-details-fragment',
  SURGERY_APPOINTMENT_DETAILS_ROUTE = 'surgery-appointment-details-route',
  TASKS_FRAGMENT = 'tasks-fragment',
  TASKS_ROUTE = 'tasks-route',
  TELECONSULTATION = 'teleconsultation',
  TEXT_DEPENDENTS = 'text-dependents',
  TEXT_PROFILE_HOLDER = 'text-profile-holder',
  WAITINGLIST_DETAILS_FRAGMENT = 'waitinglist-details-fragment',
  WAITINGLIST_DETAILS_ROUTE = 'waitinglist-details-route',
}
export { PatientRootAliases };
